import { Button } from "@mui/material";

export default function CancelButton({ ...props }) {
  return (
    <Button
      variant="outlined"
      color="blueSys"
      sx={{ boxShadow: "none", textTransform: "initial", marginRight: "16px", }}
      { ...props }
    >
      Cancelar
    </Button>
  );
}
